// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* استایل کلی برای قرار دادن فرم در مرکز صفحه */
.login-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh; /* 100% ارتفاع صفحه */
    background-color: #f5f7fa; /* پس‌زمینه نرم */
}

/* استایل فرم لاگین */
.login-form {
    background: #ffffff;
    padding: 30px;
    border-radius: 10px;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
    width: 350px;
    text-align: center;
}

/* عنوان صفحه */
.login-form h2 {
    margin-bottom: 20px;
    color: #333;
}

/* استایل ورودی‌ها */
.login-form input {
    width: 100%;
    padding: 10px;
    margin: 10px 0;
    border: 1px solid #ddd;
    border-radius: 5px;
    font-size: 16px;
}

/* استایل دکمه لاگین */
.login-form button {
    width: 100%;
    padding: 10px;
    background-color: #007bff;
    color: white;
    font-size: 16px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    transition: background 0.3s ease;
}

/* تغییر رنگ دکمه هنگام هاور */
.login-form button:hover {
    background-color: #0056b3;
}

/* استایل پیام خطای لاگین */
.error-message {
    color: red;
    font-size: 14px;
    margin-top: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/LoginPage.css"],"names":[],"mappings":"AAAA,+CAA+C;AAC/C;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa,EAAE,qBAAqB;IACpC,yBAAyB,EAAE,iBAAiB;AAChD;;AAEA,qBAAqB;AACrB;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,2CAA2C;IAC3C,YAAY;IACZ,kBAAkB;AACtB;;AAEA,eAAe;AACf;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA,oBAAoB;AACpB;IACI,WAAW;IACX,aAAa;IACb,cAAc;IACd,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;AACnB;;AAEA,sBAAsB;AACtB;IACI,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gCAAgC;AACpC;;AAEA,8BAA8B;AAC9B;IACI,yBAAyB;AAC7B;;AAEA,2BAA2B;AAC3B;IACI,UAAU;IACV,eAAe;IACf,gBAAgB;AACpB","sourcesContent":["/* استایل کلی برای قرار دادن فرم در مرکز صفحه */\n.login-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100vh; /* 100% ارتفاع صفحه */\n    background-color: #f5f7fa; /* پس‌زمینه نرم */\n}\n\n/* استایل فرم لاگین */\n.login-form {\n    background: #ffffff;\n    padding: 30px;\n    border-radius: 10px;\n    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);\n    width: 350px;\n    text-align: center;\n}\n\n/* عنوان صفحه */\n.login-form h2 {\n    margin-bottom: 20px;\n    color: #333;\n}\n\n/* استایل ورودی‌ها */\n.login-form input {\n    width: 100%;\n    padding: 10px;\n    margin: 10px 0;\n    border: 1px solid #ddd;\n    border-radius: 5px;\n    font-size: 16px;\n}\n\n/* استایل دکمه لاگین */\n.login-form button {\n    width: 100%;\n    padding: 10px;\n    background-color: #007bff;\n    color: white;\n    font-size: 16px;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    transition: background 0.3s ease;\n}\n\n/* تغییر رنگ دکمه هنگام هاور */\n.login-form button:hover {\n    background-color: #0056b3;\n}\n\n/* استایل پیام خطای لاگین */\n.error-message {\n    color: red;\n    font-size: 14px;\n    margin-top: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
